const spans = [...document.querySelectorAll("#problems ul > li:has(span)")];

function setWidth() {
  spans.forEach((item) => {
    const charsCount = item.querySelector("span").innerHTML.length;
    item.style.setProperty(
      "--_basis",
      Math.max((charsCount / 1.9).toFixed(2), 10) + "rem"
    );
    item.style.setProperty(
      "--_max-width",
      Math.max(parseInt(charsCount / 1.1), 10) + "rem"
    );
  });
}
document.addEventListener("DOMContentLoaded", setWidth);

const questions = document.querySelectorAll("#faq .question");

questions.forEach((question) => {
  question.addEventListener("click", (e) => {
    question.querySelector(".answer")?.toggleAttribute("open");
  });
});

const problemsButton = document.querySelector("#problems .show-more");

problemsButton?.addEventListener("click", () => {
  problemsButton.parentElement.querySelector(".hidden").toggleAttribute("open");
});

((d) => {
  if (
    !d.querySelector("footer .socialList") ||
    !d.querySelector("footer ul.nav-list")
  )
    return;
  if (window.innerWidth > 992) {
    setHeight();
  }
  let timer = null;
  window.addEventListener("resize", () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (window.innerWidth <= 992) return;
      setHeight();
    }, 100);
  });
  function setHeight() {
    d.querySelector("footer ul.nav-list")?.style.setProperty(
      "--_offset",
      d.querySelector("footer .socialList").offsetWidth + "px"
    );
  }
})(document);

import { updateOfferSlider } from "./swipers/offer";

// Add read more for offer text
document.addEventListener("DOMContentLoaded", function () {
  const readMoreContainers = document.querySelectorAll(".read-more-container");

  readMoreContainers.forEach((container) => {
    const textEl = container.querySelector(".read-more-text");
    const toggleBtn = container.querySelector(".read-more-toggle");
    const collapsedHeight = 138;

    if (textEl.scrollHeight > collapsedHeight + 10) {
      textEl.classList.add("collapsed");
      textEl.style.height = collapsedHeight + "px";
      toggleBtn.style.display = "inline-block";

      let isAnimating = false;

      toggleBtn.addEventListener("click", function () {
        if (isAnimating) return;
        isAnimating = true;
        function getText(slug) {
          const dict = {
            ua: {
              show: "Читати більше",
              hide: "Згорнути",
            },
            ru: {
              show: "Читать больше",
              hide: "Свернуть",
            },
          };
          return (
            dict[document.documentElement.lang]?.[slug] || dict["ua"][slug]
          );
        }

        const isCollapsed = textEl.classList.contains("collapsed");
        document
          .querySelector("#offer .swiper-wrapper")
          .classList.add("no-autoheight");

        if (isCollapsed) {
          const fullHeight = textEl.scrollHeight;

          textEl.style.height = fullHeight + "px";

          textEl.addEventListener("transitionend", function handler() {
            document
              .querySelector("#offer .swiper-wrapper")
              .classList.remove("no-autoheight");
            textEl.style.height = "auto";
            textEl.classList.remove("collapsed");
            toggleBtn.textContent = getText("hide");
            isAnimating = false;
            updateOfferSlider();
            textEl.removeEventListener("transitionend", handler);
          });
        } else {
          const currentHeight = textEl.scrollHeight;
          textEl.style.height = currentHeight + "px";

          requestAnimationFrame(() => {
            textEl.style.height = collapsedHeight + "px";
            textEl.classList.add("collapsed");
          });

          textEl.addEventListener("transitionend", function handler() {
            document
              .querySelector("#offer .swiper-wrapper")
              .classList.remove("no-autoheight");
            toggleBtn.textContent = getText("show");
            isAnimating = false;
            updateOfferSlider();
            textEl.removeEventListener("transitionend", handler);
          });
        }
      });
    }
  });
});